<template>
  <div class="section-wrapper">
    <div
      class="section-header"
      @click="!isDisabled ? toggle() : null"
      :class="{
        'is-dragging': isDragging,
        'grab-cursor': !isDisabled,
        disabled: isDisabled,
      }"
    >
      <span class="grip-icon">⠿</span>
      <h3>{{ title }}</h3>
      <button
        v-if="showCloseButton"
        class="close-button"
        @click.stop="$emit('close')"
        title="Sulje"
      >
        ×
      </button>
      <span v-else class="collapse-icon" :class="{ disabled: isDisabled }">
        {{ isCollapsed ? "▶" : "▼" }}
      </span>
    </div>
    <div v-if="!isCollapsed" class="section-content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: String,
  isCollapsed: Boolean,
  isDragging: Boolean,
  isDisabled: Boolean,
  showCloseButton: Boolean,
});

const emit = defineEmits(["toggle", "close"]);

const toggle = () => {
  emit("toggle");
};
</script>

<style scoped>
.section-wrapper {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 1rem;
  background-color: #fff;
  overflow: hidden; /* Ensures content doesn't spill out when collapsing */
}
.section-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  user-select: none;
  background-color: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}
.section-header.grab-cursor {
  cursor: grab;
}
.section-header:active {
  cursor: grabbing;
}
.section-header.is-dragging {
  background-color: #e9ecef;
}
.grip-icon {
  margin-right: 0.75rem;
  color: #888;
}
h3 {
  flex-grow: 1;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}
.collapse-icon {
  font-size: 0.8rem;
  color: #555;
}

.section-header.disabled {
  cursor: not-allowed;
  background-color: #f8f9fa;
}

.section-header.disabled h3 {
  color: #adb5bd;
}

.collapse-icon.disabled {
  color: #adb5bd;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #666;
  padding: 0.25rem;
  border-radius: 4px;
  transition:
    background-color 0.2s,
    color 0.2s;
}

.close-button:hover {
  background-color: #e9ecef;
  color: #333;
}
.section-content {
  /* No padding here, let the child component handle it */
}
/* When a section is collapsed, its wrapper has no bottom margin */
.section-wrapper:has(+ .section-wrapper) {
  margin-bottom: 1rem;
}
</style>
